import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {IconButton, Stack, TextField, Typography} from 'views/components';
import {Edit as EditIcon} from 'views/icons';
import {Translate, translate} from 'views/module';

import backend from 'utils/backend';

const errorMessage = (error) => {
  return translate(`family.FamilyMembers.Errors.${error.code === 'FAM_016' ? 'FAM_016' : 'Default'}`);
};

const FamilyName = (props) => {
  const {clientId, familyName, reload} = props;
  const progressWrap = props.statusProgressWrap;

  const [editing, setEditing] = React.useState(false);
  const [name, setName] = React.useState('');
  const [saving, setSaving] = React.useState(false);

  const openDialog = () => {
    setName(familyName ?? '');
    setEditing(true);
  };

  const closeDialog = () => setEditing(false);

  const save = async () => {
    setSaving(true);
    await progressWrap(async () => {
      await backend.loom.family.renameFamily(clientId, {name: name.trim()});
      setEditing(false);
      reload();
    }, {
      onErrorMessage: errorMessage,
      debugString: 'FAMILY_RENAME',
    });
    setSaving(false);
  };

  return (
    <>
      <Stack direction='row' spacing={1} sx={{alignItems: 'center'}}>
        <Typography sx={{fontSize: '14px', color: 'text.secondary'}}>
          <Translate expression='family.FamilyMembers.FamilyName.Title' />
        </Typography>
        <Typography sx={{fontSize: '16px', color: familyName ? 'text.primary' : 'text.secondary'}}>
          {familyName || translate('family.FamilyMembers.FamilyName.Empty')}
        </Typography>
        <IconButton
          size='small'
          aria-label={translate('family.FamilyMembers.FamilyName.EditTitle')}
          onClick={openDialog}
        >
          <EditIcon fontSize='small' />
        </IconButton>
      </Stack>
      {
        editing &&
        <Dialog onClose={closeDialog}>
          <DialogTitle onClose={closeDialog}>
            <Translate expression='family.FamilyMembers.FamilyName.EditTitle' />
          </DialogTitle>
          <DialogContent>
            <Stack sx={{pt: 1}}>
              <TextField
                fullWidth
                required
                label={translate('family.FamilyMembers.FamilyName.Title')}
                value={name}
                onChange={setName}
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' onClick={closeDialog}>
              <Translate expression='family.FamilyMembers.Cancel' />
            </Button>
            <Button disabled={!name.trim() || saving} onClick={save}>
              <Translate expression='family.FamilyMembers.Save' />
            </Button>
          </DialogActions>
        </Dialog>
      }
    </>
  );
};

FamilyName.propTypes = {
  clientId: PropTypes.string.isRequired,
  familyName: PropTypes.string,
  reload: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(FamilyName));
